module.exports = __webpack_public_path__ + "static/media/FAQ-YellowCircle.a3699fae.svg";